import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'organizedUnit/AllAcceptsClients/', method: 'GET', body: null, token: token })
}
